const state = {
  userInfo: null,
}

const getters = {
}

const mutations = {
  setUserInfo (state, v) {
    state.userInfo = v
  }
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/splice/v1frontend/splice-chat/search', { params })
  },
  view ({ state, commit, rootState }, params) {
    return rootState.axios.get('/splice/v1frontend/splice-chat/view', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
